import type { ChipVariant } from '@/components/ui/Chip/Chip'
import { Chip } from '@/components/ui'
import type { DiscrepancyStatus } from '../api/types'

const STATUS_LABELS: Record<DiscrepancyStatus, string> = {
  draft: 'Draft',
  open: 'Open',
  resolved: 'Resolved',
}

const STATUS_VARIANTS: Record<DiscrepancyStatus, ChipVariant> = {
  draft: 'neutral',
  open: 'warning',
  resolved: 'success',
}

interface Props {
  status: DiscrepancyStatus
}

export function DiscrepancyStatusChip({ status }: Props) {
  return (
    <Chip variant={STATUS_VARIANTS[status] ?? 'default'}>
      {STATUS_LABELS[status] ?? status}
    </Chip>
  )
}
